import { ActivityIndicator, StyleSheet } from "react-native";
import { useThemeColor, View } from "./Themed";

export default function Spinner () {
  return <ActivityIndicator size='small' color={useThemeColor({}, 'bluedark')} />
};
